<template>
  <div class="app-card-container">
    <div v-if="title" class="app-card__out-title">{{title}}</div>
    <v-card>
      <slot></slot>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    }
  }
};
</script>

<style lang="stylus" scoped>
.app-card-container {
  position: relative;
  margin-bottom: 2rem;
}

.app-card__out-title {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 1rem 0 1rem 0;
  font-size: 1.2rem;
}
</style>
